const styles = theme => ({
    divider: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    fullWidth: {
        width: '100%'
    }
});

export default styles;